import { motion } from "framer-motion";
import { Link } from 'react-router-dom';
import SocialIcon from "../social_icon/socialIcon";

export default function Footer() {
    
    const footerSections = [
        {
            title: 'Takamori Robot',
            items: [
                {
                    label: 'Kickstarter',
                    href: 'https://www.kickstarter.com/projects/lightning-alchemist/hiro-the-new-standard-in-robotics-platforms',
                    external: true,
                },
                {
                    label: 'Tutorial',
                    href: 'https://www.youtube.com/playlist?list=PLdfJm-tPKyeU',
                    external: true,
                },
                {
                    label: 'Robotic Kit',
                    href: '/robotickits',
                },
                {
                    label: 'For Education',
                    href: '/education',
                },
            ],
        },
        {
            title: 'About',
            items: [
                {
                    label: 'About Us',
                    href: '/about',
                },
            ],
        },
        {
            title: 'Information',
            items: [
                {
                    label: 'Contact Us',
                    href: '/contact-us',
                },
                {
                    label: 'Privacy Policy',
                    href: '/privacy-policy',
                },
                {
                    label: 'Terms of Service',
                    href: '/terms',
                },
            ],
        },
        {
            title: 'Stay Updated',
            items: [
                {
                    label: 'Sign up to stay updated about our events, products, and company news.',
                    href: null,
                },
            ],
            subscribe: 'Stay updated on Takamori Robot',
            social: true,
        },
    ];

    return (
        <footer className="flex flex-col w-full h-auto my-[3rem] items-center justify-center">
            {/* line between the decor section */}
            <motion.hr 
                className="w-full my-4 lg:my-12 h-[1px] border-0 bg-gradient-to-r from-transparent via-black to-transparent dark:via-neutral-400"
                initial={{ y: 100, opacity: 0 }}
                whileInView={{ y: 0, opacity: 1 }}
                transition={{ duration: 0.8, ease: "easeOut" }}
                viewport={{ once: true, amount: 0.4 }}
            />

            {/* footer contents */}
            <motion.div 
                className="flex flex-col md:flex-row w-[80%] xl:w-[60%] gap-y-[3rem]"
                initial={{ y: 100, opacity: 0 }}
                whileInView={{ y: 0, opacity: 1 }}
                transition={{ duration: 0.8, ease: "easeOut" }}
                viewport={{ once: true, amount: 0.4 }}
            >
                {footerSections.map((section, index) => (
                    <div key={index} className="flex flex-col md:w-1/4 gap-y-[0.5rem]">
                        <p className="font-bold text-[#249CFF]">{section.title}</p>
                        {section.items.map((item) => {
                            if (!item.href) {
                                return (
                                    <p key={item.label} className="text-[#636D67]">
                                        {item.label}
                                    </p>
                                );
                            }

                            if (item.external) {
                                return (
                                    <a
                                        key={item.label}
                                        href={item.href}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="text-[#636D67] hover:underline"
                                    >
                                        {item.label}
                                    </a>
                                );
                            }

                            return (
                                <Link
                                    key={item.label}
                                    to={item.href}
                                    className="text-[#636D67] hover:underline"
                                >
                                    {item.label}
                                </Link>
                            );
                        })}

                        {/* links to subscribe page */}
                        {section.subscribe && (
                        <Link to="/subscribe" className="text-[#249CFF] font-semibold hover:underline">
                            {section.subscribe}
                        </Link>
                        )}

                        {section.social && (
                        <div className="flex flex-row items-center gap-2 mt-2">
                            <p className="font-bold text-[#249CFF]">FOLLOW US ON</p>
                            {/* Facebook icon */}
                            <SocialIcon
                                href="https://www.facebook.com/profile.php?id=61575609549357"
                                label="Takamori Robot on Facebook"
                            >
                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12.6 0H0.733333C0.538841 0 0.352315 0.0772617 0.214788 0.214788C0.0772617 0.352315 0 0.538841 0 0.733333V12.6C0 12.6963 0.0189683 12.7917 0.0558217 12.8806C0.0926752 12.9696 0.146692 13.0504 0.214788 13.1185C0.282885 13.1866 0.363727 13.2407 0.452699 13.2775C0.541671 13.3144 0.637031 13.3333 0.733333 13.3333H7.12V8.16667H5.38667V6.16667H7.12V4.66667C7.0841 4.31451 7.12567 3.95875 7.24181 3.62436C7.35795 3.28997 7.54584 2.98503 7.79231 2.73094C8.03878 2.47685 8.33785 2.27976 8.66855 2.15349C8.99925 2.02722 9.35357 1.97483 9.70667 2C10.2256 1.99681 10.7442 2.02352 11.26 2.08V3.88H10.2C9.36 3.88 9.2 4.28 9.2 4.86V6.14667H11.2L10.94 8.14667H9.2V13.3333H12.6C12.6963 13.3333 12.7917 13.3144 12.8806 13.2775C12.9696 13.2407 13.0504 13.1866 13.1185 13.1185C13.1866 13.0504 13.2407 12.9696 13.2775 12.8806C13.3144 12.7917 13.3333 12.6963 13.3333 12.6V0.733333C13.3333 0.637031 13.3144 0.541671 13.2775 0.452699C13.2407 0.363727 13.1866 0.282885 13.1185 0.214788C13.0504 0.146692 12.9696 0.0926752 12.8806 0.0558217C12.7917 0.0189683 12.6963 0 12.6 0Z" fill="black"/>
                            </svg>
                            </SocialIcon>

                            {/* Instagram icon */}
                            <SocialIcon
                                href="https://www.instagram.com/takamori_robot/"
                                label="Takamori Robot on Instagram"
                            >
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M11.56 3.63992C11.4018 3.63992 11.2471 3.68684 11.1156 3.77474C10.984 3.86265 10.8815 3.98759 10.8209 4.13377C10.7604 4.27995 10.7445 4.44081 10.7754 4.59599C10.8063 4.75118 10.8825 4.89372 10.9944 5.0056C11.1062 5.11749 11.2488 5.19368 11.404 5.22455C11.5592 5.25541 11.72 5.23957 11.8662 5.17902C12.0124 5.11847 12.1373 5.01593 12.2252 4.88438C12.3131 4.75282 12.36 4.59814 12.36 4.43992C12.36 4.22775 12.2758 4.02426 12.1257 3.87423C11.9757 3.7242 11.7722 3.63992 11.56 3.63992ZM14.6267 5.25325C14.6137 4.70012 14.5101 4.15285 14.32 3.63325C14.1505 3.18867 13.8867 2.7861 13.5467 2.45325C13.2166 2.11154 12.8131 1.84937 12.3667 1.68659C11.8485 1.49069 11.3006 1.38473 10.7467 1.37325C10.04 1.33325 9.81337 1.33325 8.00004 1.33325C6.18671 1.33325 5.96004 1.33325 5.25337 1.37325C4.69948 1.38473 4.1516 1.49069 3.63337 1.68659C3.18782 1.85102 2.78466 2.11296 2.45337 2.45325C2.11166 2.78337 1.84949 3.18688 1.68671 3.63325C1.49081 4.15148 1.38485 4.69935 1.37337 5.25325C1.33337 5.95992 1.33337 6.18659 1.33337 7.99992C1.33337 9.81325 1.33337 10.0399 1.37337 10.7466C1.38485 11.3005 1.49081 11.8484 1.68671 12.3666C1.84949 12.813 2.11166 13.2165 2.45337 13.5466C2.78466 13.8869 3.18782 14.1488 3.63337 14.3133C4.1516 14.5091 4.69948 14.6151 5.25337 14.6266C5.96004 14.6666 6.18671 14.6666 8.00004 14.6666C9.81337 14.6666 10.04 14.6666 10.7467 14.6266C11.3006 14.6151 11.8485 14.5091 12.3667 14.3133C12.8131 14.1505 13.2166 13.8883 13.5467 13.5466C13.8882 13.215 14.1523 12.812 14.32 12.3666C14.5101 11.847 14.6137 11.2997 14.6267 10.7466C14.6267 10.0399 14.6667 9.81325 14.6667 7.99992C14.6667 6.18659 14.6667 5.95992 14.6267 5.25325ZM13.4267 10.6666C13.4219 11.0898 13.3452 11.5091 13.2 11.9066C13.0936 12.1967 12.9226 12.4589 12.7 12.6733C12.4838 12.8936 12.2222 13.0642 11.9334 13.1733C11.5358 13.3184 11.1166 13.3951 10.6934 13.3999C10.0267 13.4333 9.78004 13.4399 8.02671 13.4399C6.27337 13.4399 6.02671 13.4399 5.36004 13.3999C4.92063 13.4081 4.4831 13.3405 4.06671 13.1999C3.79056 13.0853 3.54094 12.9151 3.33337 12.6999C3.1121 12.4858 2.94327 12.2234 2.84004 11.9333C2.67728 11.53 2.587 11.1012 2.57337 10.6666C2.57337 9.99992 2.53337 9.75325 2.53337 7.99992C2.53337 6.24659 2.53337 5.99992 2.57337 5.33325C2.57636 4.90062 2.65534 4.47188 2.80671 4.06659C2.92407 3.78519 3.10422 3.53436 3.33337 3.33325C3.53592 3.10403 3.78623 2.92198 4.06671 2.79992C4.47307 2.65328 4.90137 2.57664 5.33337 2.57325C6.00004 2.57325 6.24671 2.53325 8.00004 2.53325C9.75337 2.53325 10 2.53325 10.6667 2.57325C11.0899 2.57811 11.5092 2.65475 11.9067 2.79992C12.2097 2.91235 12.4816 3.09515 12.7 3.33325C12.9185 3.53804 13.0892 3.78841 13.2 4.06659C13.3482 4.47254 13.4249 4.90111 13.4267 5.33325C13.46 5.99992 13.4667 6.24659 13.4667 7.99992C13.4667 9.75325 13.46 9.99992 13.4267 10.6666ZM8.00004 4.57992C7.32391 4.58124 6.66335 4.78294 6.10181 5.15953C5.54027 5.53613 5.10296 6.07072 4.84513 6.69575C4.5873 7.32079 4.52052 8.00823 4.65324 8.67121C4.78595 9.33418 5.1122 9.94294 5.59076 10.4206C6.06932 10.8982 6.67871 11.2233 7.34195 11.3547C8.00518 11.4861 8.69248 11.418 9.31702 11.1589C9.94156 10.8999 10.4753 10.4615 10.8508 9.89927C11.2263 9.337 11.4267 8.67605 11.4267 7.99992C11.4276 7.54999 11.3395 7.10432 11.1675 6.68856C10.9956 6.27279 10.7431 5.89513 10.4246 5.57729C10.1062 5.25945 9.72801 5.0077 9.31191 4.83654C8.8958 4.66537 8.44997 4.57816 8.00004 4.57992ZM8.00004 10.2199C7.56097 10.2199 7.13175 10.0897 6.76667 9.84578C6.4016 9.60184 6.11705 9.25513 5.94903 8.84948C5.781 8.44382 5.73704 7.99746 5.8227 7.56682C5.90836 7.13618 6.11979 6.74061 6.43026 6.43014C6.74074 6.11967 7.1363 5.90823 7.56694 5.82258C7.99758 5.73692 8.44395 5.78088 8.8496 5.94891C9.25525 6.11693 9.60197 6.40148 9.8459 6.76655C10.0898 7.13163 10.22 7.56084 10.22 7.99992C10.22 8.29145 10.1626 8.58013 10.0511 8.84948C9.93949 9.11882 9.77596 9.36355 9.56982 9.5697C9.36367 9.77584 9.11894 9.93937 8.8496 10.0509C8.58026 10.1625 8.29158 10.2199 8.00004 10.2199Z" fill="black"/>
                            </svg>
                            </SocialIcon>

                            {/* LinkedIn icon */}
                            {/*
                              SocialIcon destructures `label` and hardcodes
                              target/rel, so the old aria-label/target/rel props
                              here were silently dropped — the link had no
                              accessible name. Use `label`.
                            */}
                            <SocialIcon
                                href="https://www.linkedin.com/company/takamori-robot/"
                                label="Takamori Robot on LinkedIn"
                            >
                                <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M13.8829 1.64227H2.19627C1.55769 1.64227 0.999756 2.10175 0.999756 2.73282V14.4454C0.999756 15.0799 1.55769 15.6453 2.19627 15.6453H13.8794C14.5214 15.6453 15.0028 15.0761 15.0028 14.4454V2.73282C15.0066 2.10175 14.5214 1.64227 13.8829 1.64227ZM5.34039 13.3145H3.33433V7.07721H5.34039V13.3145ZM4.40675 6.12887H4.39237C3.75035 6.12887 3.33464 5.65096 3.33464 5.0527C3.33464 4.44351 3.76129 3.97684 4.41769 3.97684C5.07408 3.97684 5.47573 4.44007 5.49011 5.0527C5.4898 5.65096 5.07408 6.12887 4.40675 6.12887ZM12.672 13.3145H10.6659V9.90407C10.6659 9.08702 10.374 8.52877 9.6482 8.52877C9.0937 8.52877 8.76551 8.90385 8.61954 9.26925C8.56484 9.40052 8.55015 9.57931 8.55015 9.76185V13.3145H6.54409V7.07721H8.55015V7.94521C8.84209 7.52949 9.29812 6.93124 10.3593 6.93124C11.6761 6.93124 12.6723 7.79924 12.6723 9.67058L12.672 13.3145Z" fill="black"/>
                                </svg>
                            </SocialIcon>
                        </div>
                        )}
                    </div>
                ))}
            </motion.div>
            <div className="w-[80%] xl:w-[60%] mt-6 text-left">
                <p className="text-sm text-gray-500">
                    © 2026 Takamori Robot (takamorirobot.com) – All Rights Reserved.
                </p>
            </div>
        </footer>
    )
}